import styled from 'styled-components';
export var ListContainer = styled.ul.withConfig({
  displayName: "partials__ListContainer",
  componentId: "sc-1w166bn-0"
})(["text-align:left;"]);
export var Block = styled.div.withConfig({
  displayName: "partials__Block",
  componentId: "sc-1w166bn-1"
})(["display:", ";"], function (_ref) {
  var _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? true : _ref$inline;
  return inline ? 'inline' : 'block';
});